'use strict';
import React, { Component } from 'react';

class Eliminacion extends Component {
    render() {
        return (
            <div className="dropdown">
                <p>ELIMINADO</p>
            </div>
        );
    }

}

export default Eliminacion